import {PaginationModel} from "@core/models/pagination.model";

export class FilterOrderRequest extends PaginationModel{
  customerName: string = null;
  address: string = null;
  phoneNumber: string = null;
  moreInfor: string = null;
  createdDate : Date = null;
  channel: number = null;
  channelPayment: number = null;
  product: string = null;
  fromDate: number =null;
  toDate: number =null;
  paid: number = null;
  isShipped: number = null;
  orderId: number = null;

}
